import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      // Default styles for all badges
    },
    // Customize specific color variants
    colorInfo: {
      backgroundColor: Colors.BLUE300, // #35A4E8 color for background
      color: Colors.WHITE, // #FFFFFF color for text
    },
  },
};
